import React from "react";
import styled from "styled-components";
import { ReactComponent as SmallSpinner } from "../../img/SmallSpinner.svg";

const StyledSpinnerWrapper = styled.div`
	display: inline-block;
	vertical-align: sub;
	position: relative;
	width: 20px;
	height: 20px;
	margin: 0 5px;
	svg {
		position: absolute;
		height: 100%;
		width: 100%;
		left: 0;
		top: 0;
	}
`;

const SmallLoader = () => {
	return (
		<StyledSpinnerWrapper>
			<SmallSpinner />
		</StyledSpinnerWrapper>
	);
};
export default SmallLoader;
